import { render, staticRenderFns } from "./adultInquiry.vue?vue&type=template&id=2fb1006c&scoped=true&"
import script from "./adultInquiry.vue?vue&type=script&lang=js&"
export * from "./adultInquiry.vue?vue&type=script&lang=js&"
import style0 from "./adultInquiry.vue?vue&type=style&index=0&id=2fb1006c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb1006c",
  null
  
)

export default component.exports